import { render, staticRenderFns } from "./DurationSelection.vue?vue&type=template&id=542f7270&scoped=true&"
import script from "./DurationSelection.vue?vue&type=script&lang=js&"
export * from "./DurationSelection.vue?vue&type=script&lang=js&"
import style0 from "./DurationSelection.vue?vue&type=style&index=0&id=542f7270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f7270",
  null
  
)

export default component.exports